/* import __COLOCATED_TEMPLATE__ from './trial-confirmation-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();